// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Nu4rZ","content":"RecentSearches_content__1KMb-"};